<template>
  <v-card>
    <v-card-title class="align-center justify-center third white--text mb-4">
      Historique
      <span v-if="!loading" class="ml-2">({{ formattedContractSessions.length }} / {{ contractTotalStock }})</span>
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader v-if="loading" class="mx-auto" min-height="500" type="table-tbody" />
      <v-data-table
        v-else
        :headers="headers"
        :items="formattedContractSessions"
        :items-per-page="5"
        item-key="rowId"
        sort-by="end_time"
        sort-desc
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api';
import { format, fromUnixTime } from 'date-fns';
import { sendNotification } from '@/helpers/utils';
import { getContractSessions } from '@/helpers/request';

export default {
  props: {
    contract: { type: Object, default: () => ({}) },
    initialStock: { type: Number, default: 0 },
    contractHistory: { type: Array, default: () => [] }
  },
  setup (props) {
    const loading = ref(false);
    const contractSessions = ref([]);

    const headers = [
      { text: 'Date et heure', value: 'date', width: '30%', align: 'center', sortable: true },
      { text: 'Séance', value: 'sessionName', width: '25%', align: 'center', sortable: false },
      { text: 'Nom du participant', value: 'fullname', width: '25%', align: 'center', sortable: false },
      { text: 'Cheval', value: 'horse', width: '20%', align: 'center', sortable: false }
    ];

    const contractTotalStock = computed(() => {
      let total = props.initialStock;
      if (props.contractHistory && props.contractHistory.length) {
        const totalEditedStock = props.contractHistory.reduce((acc, item) => acc + parseInt(item.newStock) - parseInt(item.oldStock), 0);
        total = total + totalEditedStock;
      }
      return total;
    });

    const formattedContractSessions = computed(() => {
      if (!contractSessions.value || !Array.isArray(contractSessions.value)) return [];
      const contractNumber = props.contract?.contractNumber;
      if (!contractNumber) return [];

      const result = [];
      contractSessions.value.forEach(session => {
        (session.participants || [])
          .filter(participant => parseInt(participant.contract_number) === parseInt(contractNumber))
          .forEach(participant => {
            result.push({
              rowId: `${session.id}_${participant.uuid}`,
              date: `Le ${format(fromUnixTime(session.start_time), 'dd/MM/yyyy')}, de ${format(fromUnixTime(session.start_time), 'HH:mm')} à ${format(fromUnixTime(session.end_time), 'HH:mm')}`,
              sessionName: session.name,
              fullname: `${participant.firstname || ''} ${participant.lastname || ''}`.trim(),
              horse: participant.horse || '-',
              end_time: session.end_time
            });
          });
      });
      return result;
    });

    const loadContractSessions = async () => {
      if (!props.contract?.contractNumber || !props.contract?.workspace || !props.contract?.validityStart || !props.contract?.validityEnd) {
        return;
      }
      const startDate = new Date(props.contract.validityStart).getTime();
      const endDate = new Date(props.contract.validityEnd).getTime();

      const response = await getContractSessions(props.contract.contractNumber, props.contract.workspace, startDate, endDate);
      if (!response.success) {
        throw new Error('Error in getContractSessions request');
      }
      contractSessions.value = response.data;
    };

    onMounted(async () => {
      loading.value = true;
      try {
        await loadContractSessions();
      } catch (error) {
        console.error('Error in ContractSessionHistory mounted:', error);
        sendNotification('error', 'Erreur lors de la récupération des sessions');
      }
      loading.value = false;
    });

    return { loading, headers, formattedContractSessions, contractTotalStock };
  }
};
</script>
